export const getEditDestinationAddressPayload = (address, requiresCustomerTaxId) => {
  const payload = {
    recipient_address: {
      ...address,
      country: address?.country?.code,
      phone: address?.phone,
      province: address?.province?.code,
    },
  }

  delete payload.recipient_address?.customer

  if (requiresCustomerTaxId) {
    payload.customer = {
      tax_id: address?.customer?.tax_id,
    }
  }

  return payload
}
